import { Component, ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ProductService } from '../../services/productservice';
@Component({
  selector: 'terms_of_use',
  templateUrl: './termsofuse.component.html',
  styleUrls: ['./termsofuse.component.scss'],
})
export class TermsofuseComponent implements OnInit {
  public termsOfUseDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  images: any = [];
  activeIndex: any;
  constructor(public productService: ProductService, private elementRef: ElementRef, private titleService: Title) {}

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  ngOnInit(): void {
    this.getTermsOfUseDetails();
    this.loadScripts();
  }
  getTermsOfUseDetails() {
    this.productService.getTermsAndConditionsDetails().subscribe((data) => {
      this.termsOfUseDetails = data;
      this.images.push(this.termsOfUseDetails.bannerImage);
      this.titleService.setTitle(this.termsOfUseDetails.bannerTitle + ' ' + '| The Seychelles Islands');
    });
  }
  loadScripts() {
    var body = this.elementRef.nativeElement.querySelector('.termsOfUse');
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    script.defer = true;
    script.lang = 'en';
    body.appendChild(script);
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
